import { ContainerDetailsModel } from "src/components/common/container-details/ContainerDetailsModel";

export enum GetContainerMode {
    CONTAINERIZATION = 'CONTAINERIZATION',
    IDENTIFICATION = 'IDENTIFICATION',
    PRINT = 'PRINT',
    SEARCH = 'SEARCH',
    RECEIVE = 'RECEIVE',
    MOVE = 'MOVE',
    SEND_TO_PROCESS = 'SEND_TO_PROCESS',
    SORT = 'SORT',
    UNLOAD = 'UNLOAD'
}

export interface GetContainerDetailsInput {
    containerId: string;
    associate: string;
    warehouseId: string;
    includeChildren: boolean;
    mode?: GetContainerMode;
    locale?: string;
    movingContainers?: ContainerDetailsModel[];
}

export interface GetContainerDetailsOutput {
    container: ContainerDetailsModel;
    childContainers: ContainerDetailsModel[];
}

export const buildGetContainerDetailsInput = (containerId: string,
                                              warehouseId: string, associate: string, locale: string,
                                              mode: GetContainerMode,
                                              includeChildren: boolean = false,
                                              movingContainers: ContainerDetailsModel[] = []): GetContainerDetailsInput => {
    return {
        containerId,
        warehouseId,
        associate,
        includeChildren,
        mode,
        locale,
        movingContainers
    }

}
